import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import AddImagesDemo from "../ComponentDemoPage/demos/AddImagesDemo";
import ImagesDemo from "../ComponentDemoPage/demos/ImagesDemo";
import AttachFilesDemo from "../ComponentDemoPage/demos/AttachFilesDemo";
import FilesDemo from "../ComponentDemoPage/demos/FilesDemo";
import AttachArticleDemo from "../ComponentDemoPage/demos/AttachArticleDemo";
import AttachArticlesDemo from "../ComponentDemoPage/demos/AttachArticlesDemo";
import MultipleArticlesDemo from "../ComponentDemoPage/demos/MultipleArticlesDemo";
import MultipleArticlesTopDemo from "../ComponentDemoPage/demos/MultipleArticlesTopDemo";
import EditArticlesOrderedDetailsDemo from "../ComponentDemoPage/demos/EditArticlesOrderedDetailsDemo";
import TitledArticleViewerFragmentDemo from "../ComponentDemoPage/demos/TitledArticleViewerFragmentDemo";
import ArticlesCreatorFragmentDemo from "../ComponentDemoPage/demos/ArticlesCreatorFragmentDemo";
import styles from "../shared.module.css";

function FilesAndArticlesPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Files & Articles" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "Files & Articles" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          Files & Articles
        </FixaText>

        <FixaText tagName="h3" textStyle="Heading.L">
          Images
        </FixaText>
        <AddImagesDemo />
        <ImagesDemo />

        <FixaText tagName="h3" textStyle="Heading.L">
          Files
        </FixaText>
        <AttachFilesDemo />
        <FilesDemo />

        <FixaText tagName="h3" textStyle="Heading.L">
          Articles
        </FixaText>
        <AttachArticleDemo />
        <AttachArticlesDemo />
        <ArticlesCreatorFragmentDemo />
        <MultipleArticlesDemo />
        <MultipleArticlesTopDemo />
        <EditArticlesOrderedDetailsDemo />
        <TitledArticleViewerFragmentDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default FilesAndArticlesPage;
